import { render, staticRenderFns } from "./ClubRoastersComponent.vue?vue&type=template&id=1e066f0c"
import script from "./ClubRoastersComponent.vue?vue&type=script&lang=js"
export * from "./ClubRoastersComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports